/* dp-cart.js — eigen scripts van rol cart (Dailyplay-audit 24-09-2026, Wim). */
(function () {
  // /cart (cz-10): de winkelwagen ís de Kaching-lade. Zodra die app zijn element definieert, maakt de
  // winkelwagenpagina plaats voor één blok dat de lade opent; zonder Kaching blijft de thema-wagen staan.
  // Gemeten 24-09: het custom element heet <kaching-cart> (de lade <kaching-cart-drawer> is een gewoon
  // element erbinnen) en window.kachingCartApi.openCart() opent de lade.
  var pagina = document.querySelector('[data-dp-cartpage]');
  if (!pagina || !window.customElements) return;
  window.customElements.whenDefined('kaching-cart').then(function () {
    pagina.classList.add('dp-cart--lade');
    var blok = pagina.querySelector('.dp-cart-lade');
    if (blok) blok.hidden = false;
    var knop = pagina.querySelector('[data-dp-open-lade]');
    if (knop) knop.addEventListener('click', function (e) {
      var api = window.kachingCartApi;
      if (api && typeof api.openCart === 'function') { e.preventDefault(); api.openCart(); }
    });
  }).catch(function () {});
})();

(function () {
  // Foutmelding bij toevoegen (cz-23): het thema toont de ruwe tekst uit /cart/add.js ("Please try again in a few
  // minutes" bij een 429), en omdat er twee koopknoppen op de pagina luisteren stond hij er twee keer. Het event
  // cart:error wordt op het productformulier afgevuurd; wij luisteren in de capture-fase op window, dus vóór de
  // knoppen, en vertalen alleen Engelse tekst. Daarna blijft er per tekst één melding over.
  function vertaal(t) {
    var s = String(t || '');
    var engels = /\b(please|try again|the cart|your cart|can't|cannot|sold out|in stock|already|unavailable|error)\b/i.test(s);
    var nl = /\b(je|het|de|niet|winkelwagen|voorraad)\b/i.test(s);
    if (!engels || nl) return s;
    if (/try again|too many/i.test(s)) return 'Toevoegen lukte even niet. Probeer het over een minuut opnieuw.';
    if (/sold out|in stock|can.t add|cannot add|are in your cart|unavailable/i.test(s)) return 'Er is niet genoeg voorraad om dit aantal toe te voegen.';
    return 'Toevoegen lukte niet. Probeer het opnieuw.';
  }
  function ontdubbel() {
    var gezien = {};
    document.querySelectorAll('.banner--error[role="alert"]').forEach(function (b) {
      var sleutel = b.textContent.replace(/\s+/g, ' ').trim();
      if (!sleutel) return;
      if (gezien[sleutel]) { b.remove(); } else { gezien[sleutel] = true; }
    });
  }
  window.addEventListener('cart:error', function (e) {
    try {
      if (e.detail && typeof e.detail.error === 'string') e.detail.error = vertaal(e.detail.error);
    } catch (x) { /* de melding van het thema blijft dan zoals hij was */ }
    setTimeout(ontdubbel, 0);
  }, true);
})();

(function () {
  // Gratis accessoires in de lade (Wim 24-09-2026, opdracht Cas): klanten vroegen zich af of de accessoires van de
  // productpagina ("Je ontvangt gratis accessoires") ook in de wagen zitten. Onder elke regel van de Kaching-lade komt
  // daarom een klein lijstje. ALLEEN WEERGAVE: er komt geen orderregel bij (de accessoires zitten al in de verpakking).
  // Data: sections/dp-cart-cadeaus.liquid (zelfde metaobjecten als het blok op de productpagina), één verzoek per
  // nieuw product in de wagen. Kachings eigen cadeauregels (.kaching-promotion-item) blijven onaangeroerd.
  var SECTIE = 'dp-cart-cadeaus', OPSLAG = 'dp-cadeaus-v1';
  var kaart = {};
  try { kaart = JSON.parse(window.sessionStorage.getItem(OPSLAG) || '{}') || {}; } catch (e) { kaart = {}; }
  var gevraagd = {}, bezig = false, wortel = null, wacht = null;

  function euro(c) { return '€' + (Math.round(c) / 100).toFixed(2).replace('.', ','); }
  function tekst(s) { var d = document.createElement('div'); d.textContent = String(s == null ? '' : s); return d.innerHTML; }
  function aantal(item) {
    var i = item.querySelector('.kaching-cart-item__quantity-input');
    var n = i ? parseInt(i.value, 10) : NaN;
    return n > 0 ? n : 1;
  }
  function isKachingCadeau(item) {
    // Een regel die Kaching zelf als cadeau toevoegt draagt de eigenschap _kaching_cart; die krijgt nooit een lijstje.
    try {
      var api = window.kachingCartApi, data = api && api.getCartData && api.getCartData();
      var sleutel = item.getAttribute('data-line-key');
      var regels = (data && data.items) || [];
      for (var k = 0; k < regels.length; k++) {
        if (regels[k].key === sleutel) return !!(regels[k].properties && regels[k].properties._kaching_cart);
      }
    } catch (e) { /* onbekend = gewone regel */ }
    return false;
  }
  function bouw(lijst, n, sig) {
    var el = document.createElement('div');
    el.className = 'dp-cadeaus';
    el.setAttribute('data-dp-cadeaus-sig', sig);
    var h = '<p class="dp-cadeaus__kop"><svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>Gratis erbij</p><ul class="dp-cadeaus__lijst">';
    for (var k = 0; k < lijst.length; k++) {
      var g = lijst[k];
      h += '<li class="dp-cadeaus__regel"><span class="dp-cadeaus__naam">' + (n > 1 ? n + '× ' : '') + tekst(g.t) + '</span>'
        + '<span class="dp-cadeaus__prijs"><s>' + euro((g.c || 0) * n) + '</s> <strong>Gratis</strong></span></li>';
    }
    el.innerHTML = h + '</ul>';
    // Een klik in het lijstje hoort niet bij de lade eromheen.
    el.addEventListener('click', function (e) { e.stopPropagation(); });
    return el;
  }
  function inspring(item, el) {
    // Lijn het lijstje uit met de tekstkolom van de regel (links en rechts) en trek het omhoog tot vlak onder de
    // knoppen, naast de productfoto; zo hoort het zichtbaar bij déze regel. Gemeten, want Kaching gebruikt op mobiel
    // andere marges dan op desktop. Zonder opmaak (lade dicht) blijft de vorige stand staan.
    var c = item.querySelector('.kaching-cart-item__content');
    if (!c) return;
    var bi = item.getBoundingClientRect(), bc = c.getBoundingClientRect();
    if (!bi.width || !bc.width) return;
    var m = Math.round(bc.bottom + 6 - bi.bottom) + 'px ' + Math.round(bi.right - bc.right) + 'px 12px ' + Math.round(bc.left - bi.left) + 'px';
    if (el.getAttribute('data-dp-marge') !== m) { el.style.margin = m; el.setAttribute('data-dp-marge', m); }
  }
  function haal(ids) {
    if (bezig) return;
    bezig = true;
    ids.forEach(function (id) { gevraagd[id] = true; });
    var basis = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(basis + '?sections=' + SECTIE, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var html = j && j[SECTIE];
        var m = html && html.match(/<script type="application\/json" data-dp-cadeaus>([\s\S]*?)<\/script>/);
        if (!m) return;
        var nieuw = JSON.parse(m[1]);
        for (var id in nieuw) if (Object.prototype.hasOwnProperty.call(nieuw, id)) kaart[id] = nieuw[id];
        try { window.sessionStorage.setItem(OPSLAG, JSON.stringify(kaart)); } catch (e) { /* alleen gemak */ }
      })
      .catch(function () { /* geen lijstje is de oude stand; de lade zelf werkt gewoon */ })
      .then(function () { bezig = false; plan(); });
  }
  function werkBij() {
    if (!wortel) return;
    var items = wortel.querySelectorAll('.kaching-cart-item[data-product-id]');
    var onbekend = [];
    for (var k = 0; k < items.length; k++) {
      var item = items[k], id = item.getAttribute('data-product-id');
      var volgende = item.nextElementSibling;
      var bestaand = volgende && volgende.classList.contains('dp-cadeaus') ? volgende : null;
      var lijst = isKachingCadeau(item) ? [] : kaart[id];
      if (lijst === undefined) { if (!gevraagd[id]) onbekend.push(id); lijst = []; }
      if (!lijst.length) { if (bestaand) bestaand.remove(); continue; }
      var n = aantal(item), sig = id + ':' + n + ':' + lijst.length;
      if (bestaand && bestaand.getAttribute('data-dp-cadeaus-sig') === sig) { inspring(item, bestaand); continue; }
      var el = bouw(lijst, n, sig);
      if (bestaand) bestaand.replaceWith(el); else item.after(el);
      inspring(item, el);
    }
    // Verweesd lijstje (Kaching verplaatste of verving de regel): weg ermee.
    var eigen = wortel.querySelectorAll('.dp-cadeaus');
    for (var q = 0; q < eigen.length; q++) {
      var vorige = eigen[q].previousElementSibling;
      if (!vorige || !vorige.classList.contains('kaching-cart-item')) eigen[q].remove();
    }
    if (onbekend.length) haal(onbekend);
  }
  function plan() {
    if (wacht) return;
    wacht = setTimeout(function () { wacht = null; werkBij(); }, 60);
  }
  if (!window.customElements || !window.MutationObserver) return;
  window.customElements.whenDefined('kaching-cart').then(function () {
    wortel = document.querySelector('kaching-cart');
    if (!wortel) return;
    new MutationObserver(plan).observe(wortel, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['open'] });
    // Aantal via + / - of intypen: het invoerveld zelf muteert geen DOM, dus luisteren we er ook direct naar.
    wortel.addEventListener('click', function () { setTimeout(plan, 400); setTimeout(plan, 1500); }, true);
    wortel.addEventListener('change', plan, true);
    wortel.addEventListener('input', plan, true);
    plan();
  }).catch(function () {});
})();
